import swal from "sweetalert";
import {
  CREATE_DROP_DOWN_VALUE_FAIL,
  CREATE_DROP_DOWN_VALUE_REQUEST,
  CREATE_DROP_DOWN_VALUE_SUCCESS,
  CREATE_FIELD_FAIL,
  CREATE_FIELD_REQUEST,
  CREATE_FIELD_SUCCESS,
  CREATE_SECTION_FORM_FAIL,
  CREATE_SECTION_FORM_REQUEST,
  CREATE_SECTION_FORM_SUCCESS,
  DELETE_DROP_DOWN_VALUE_FAIL,
  DELETE_DROP_DOWN_VALUE_REQUEST,
  DELETE_DROP_DOWN_VALUE_SUCCESS,
  DELETE_FIELD_FAIL,
  DELETE_FIELD_REQUEST,
  DELETE_FIELD_SUCCESS,
  FETCH_FIELD_FAIL,
  FETCH_FIELD_REQUEST,
  FETCH_FIELD_SUCCESS,
  FETCH_SECTION_FORM_FAIL,
  FETCH_SECTION_FORM_REQUEST,
  FETCH_SECTION_FORM_SUCCESS,
  SHOW_DROP_DOWN_VALUE_FAIL,
  SHOW_DROP_DOWN_VALUE_REQUEST,
  SHOW_DROP_DOWN_VALUE_SUCCESS,
  SHOW_FIELD_FAIL,
  SHOW_FIELD_REQUEST,
  SHOW_FIELD_SUCCESS,
} from "../../ActionType/Section&FieldsTypes/SectionFielsTypes";
import { api } from "../../Api/api";
import { getToken } from "../login";

export const getSectionFormAction = () => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: FETCH_SECTION_FORM_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("sectionForm", config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_SECTION_FORM_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_SECTION_FORM_FAIL,
      payload: [],
      erorr: error,
    });
  }
};

export const createSectionFormAction = (form_id, title) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: CREATE_SECTION_FORM_REQUEST,
    payload: [],
  });
  try {
    const response = await api.post(
      "sectionForm/create",
      {
        form_id,
        title,
      },
      config
    );
    const { status, data } = response;

    if (status == 201) {
      dispatch(getSectionFormAction());
      dispatch(getSectionFormAction());
      swal({
        title: "Good job!",
        text: "Section Form was saved Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: CREATE_SECTION_FORM_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_SECTION_FORM_FAIL,
      payload: [],
      erorr: error,
    });
  }
};

export const updateSectionFormAction = (id, title) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: CREATE_SECTION_FORM_REQUEST,
    payload: [],
  });
  try {
    const response = await api.patch(
      "sectionForm/update/" + id,
      { title },
      config
    );
    const { status, data } = response;

    if (status == 200) {
      dispatch(getSectionFormAction());
      dispatch(getSectionFormAction());
      swal({
        title: "Good job!",
        text: "Section Form was Update Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: CREATE_SECTION_FORM_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: CREATE_SECTION_FORM_FAIL,
      payload: [],
      erorr: error,
    });
  }
};

export const createFieldFormAction =
  (section_form_id, name, type, label, placeholder) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_FIELD_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "fields/create",
        {
          section_form_id,
          name,
          type,
          label,
          placeholder,
        },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        swal({
          title: "Good job!",
          text: "Fildes Form was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_FIELD_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_FIELD_FAIL,
        payload: [],
        erorr: error,
      });
    }
  };

export const updateFieldFormAction =
  (id, section_form_id, name, type, label, placeholder) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_FIELD_REQUEST,
      payload: [],
    });
    try {
      const response = await api.put(
        "fields/update/" + id,
        {
          section_form_id,
          name,
          type,
          label,
          placeholder,
        },
        config
      );
      const { status, data } = response;

      if (status == 200) {
        dispatch(getFieldFormAction(section_form_id));
        dispatch(getFieldFormAction(section_form_id));
        swal({
          title: "Good job!",
          text: "Fildes Form was updated Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_FIELD_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_FIELD_FAIL,
        payload: [],
        erorr: error,
      });
    }
  };

export const getFieldFormAction = (section_form_id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    params: {
      section_form_id,
    },
  };
  dispatch({
    type: FETCH_FIELD_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get("fields", config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: FETCH_FIELD_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    dispatch({
      type: FETCH_FIELD_FAIL,
      payload: [],
      erorr: error,
    });
  }
};


export const deleteFieldFormAction = (id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: DELETE_FIELD_REQUEST,
    payload: [],
  });
  try {
    const response = await api.delete(`fields/delete/${id}`, config);
    const { status, data } = response;

    if (status == 200) {
      swal({
        title: "Good job!",
        text: "drop down  was delete Successfully !",
        icon: "success",
        button: "OK",
        timer: 2000,
      });
      dispatch({
        type: DELETE_FIELD_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: DELETE_FIELD_FAIL,
      payload: [],
      erorr: error,
    });
  }
};

export const createDropDownValueFormAction =
  (field_id, value) => async (dispatch) => {
    const config = {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    };
    dispatch({
      type: CREATE_DROP_DOWN_VALUE_REQUEST,
      payload: [],
    });
    try {
      const response = await api.post(
        "dropdown/create",
        {
          field_id,
          value,
        },
        config
      );
      const { status, data } = response;

      if (status == 201) {
        swal({
          title: "Good job!",
          text: "drop down  was saved Successfully !",
          icon: "success",
          button: "OK",
          timer: 2000,
        });
        dispatch({
          type: CREATE_DROP_DOWN_VALUE_SUCCESS,
          payload: data,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_DROP_DOWN_VALUE_FAIL,
        payload: [],
        erorr: error,
      });
    }
  };

export const showDropDownValueFormAction = (id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: SHOW_DROP_DOWN_VALUE_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get(`dropdown/show/${id}`, config);
    const { status, data } = response;
    console.log("resp : ", response)
    if (status == 200) {
      dispatch({
        type: SHOW_DROP_DOWN_VALUE_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    console.log(error)
    dispatch({
      type: SHOW_DROP_DOWN_VALUE_FAIL,
      payload: [],
      erorr: error,
    });
  }
};

export const deleteDropDownValueFormAction = (id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: DELETE_DROP_DOWN_VALUE_REQUEST,
    payload: [],
  });
  try {
    const response = await api.delete(`dropdown/delete/${id}`, config);
    const { status, data } = response;

    if (status == 200) {
      dispatch({
        type: DELETE_DROP_DOWN_VALUE_SUCCESS,
        payload: data,
      });
    }
  } catch (error) {
    // console.log(error)
    dispatch({
      type: DELETE_DROP_DOWN_VALUE_FAIL,
      payload: [],
      erorr: error,
    });
  }
};

export const showFieldFormAction = (id) => async (dispatch) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
  };
  dispatch({
    type: SHOW_FIELD_REQUEST,
    payload: [],
  });
  try {
    const response = await api.get(`fields/show/${id}`, config);
    const { status, data } = response;

    if (status == 200) {

      dispatch({
        type: SHOW_FIELD_SUCCESS,
        payload: response.data,
      });
    }
  } catch (error) {
    dispatch({
      type: SHOW_FIELD_FAIL,
      payload: [],
      erorr: error,
    });
  }
};
